import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Modal_Empleados from './modal_empleados';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';
import ReactExport from "react-data-export";
import {sendLog} from '../../util'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const database=firebase.database();


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px',
	height: '500px'
	
  }
};

class Empleados extends Component{
	
	
	constructor(props){
		
		super(props);
		this.state={
			
			empleados:[],
			socios:[],
			vehiculos:[],
			vehiculos1:[],
			isActive:false,
			isActiveSocios:false,
			isActiveVehiculos:false,
			keyRow:'',
			vehiculoKey:'',
			direccion:'',
			dui:'',
			edad:'',
			latitud:'',
			longitud:'',
			licencia:'',
			nombre:'',
			placa:'',
			vehiculo:'',
			socio:'',
			telefono:'',
			foto:'',
			uploadValue:0,
			files:null,
			nombreSocio:'',
			marca:'',
			modelo:'',
			vehiculoAnterior:'',
			template:false,
			anchoActual:'',
			anchoAnterior:'',
			checkboxValue:false,
			checkAdmin:false
			
		}
		
		this.empleadosRef=database.ref().child('Empleados');
		this.empleadosGPSRef=database.ref().child('EmpleadosGPS');
		this.sociosRef=database.ref().child('Socios');
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.handleUpload=this.handleUpload.bind(this);
		this.handleClickVehiculos=this.handleClickVehiculos.bind(this);
		this.btnVehiculosFormatter=this.btnVehiculosFormatter.bind(this);
		this.updateRow=this.updateRow.bind(this);
		this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		this.handleKeyPressLicencia=this.handleKeyPressLicencia.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.asignarAncho=this.asignarAncho.bind(this);

	
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
		this.setState({
			
			anchoAnterior:window.innerWidth,
			anchoActual:window.innerWidth
			
		})
		
		
	}
	
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	handleClickClose(){		
		Alert.closeAll();
	}
	
	componentWillMount(){

		Modal.setAppElement('body');
	}

	
	componentDidMount() {
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);
		this.vehiculosRef.on('value',this.gotDataVehiculos,this.errDataVehiculos);
		this.empleadosRef.on('value', this.gotData, this.errData);
		this.checkSAdmin();
	}
	
	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				let data = element.val();
				data.key = element.key;
				if (data.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}
	
	//get the data from the firebase and push them out
	gotDataVehiculos = (data) => {
		  let newVehiculo = []
		  let newVehiculo1 = []
		  if(data.val()!==null){
		  const vehiculodata = data.val();
		  const keys = Object.keys(vehiculodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
					
			if(vehiculodata[k].estado==='Disponible'){
				newVehiculo.push({
					key:k,
					vehiculoAnterior:k,
					anio:vehiculodata[k].anio,
					capacidad:vehiculodata[k].capacidad,
					codigo_socio:vehiculodata[k].codigo_socio,
					disponibilidad:vehiculodata[k].disponibilidad,
					estado:vehiculodata[k].estado,
					foto:vehiculodata[k].foto,
					marca:vehiculodata[k].marca,
					modelo:vehiculodata[k].modelo,
					placa:vehiculodata[k].placa,
					// tipo_vehiculo:vehiculodata[k].tipo_vehiculo,
					movil:vehiculodata[k].movil
			  
				  });
			}
			newVehiculo1.push({
				key:k,
				vehiculoAnterior:k,
				anio:vehiculodata[k].anio,
				capacidad:vehiculodata[k].capacidad,
				codigo_socio:vehiculodata[k].codigo_socio,
				disponibilidad:vehiculodata[k].disponibilidad,
				estado:vehiculodata[k].estado,
				foto:vehiculodata[k].foto,
				marca:vehiculodata[k].marca,
				modelo:vehiculodata[k].modelo,
				placa:vehiculodata[k].placa,
				// tipo_vehiculo:vehiculodata[k].tipo_vehiculo,
				movil:vehiculodata[k].movil
		  
			  });
		  }
		  this.setState({vehiculos: newVehiculo,vehiculos1:newVehiculo1});
		}
		}
		errDataVehiculos = (err) => {
	  console.log(err);
	}
	
	llenar(){
			
		this.state.vehiculos = this.state.vehiculos1.filter(vehiculo => vehiculo.estado==="Disponible" && vehiculo.placa!==undefined && vehiculo.marca!=="ELIMINADO")
	}
	
	toggleModalVehiculos=()=>{
			
		if(this.state.socio!==''){
			
			this.setState({
				isActiveVehiculos:!this.state.isActiveVehiculos
			
			})
		
		}
		
	}
	
	
	//get the data from the firebase and push them out
	gotData = (data) => {
		
		  let nombreSocio='';
		  let movil='';
		  let newEmpleado = [];
		  if(data.val()!==null){
		  const empleadodata = data.val();
		  const keys = Object.keys(empleadodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			for(let j=0;j<this.state.socios.length;j++){
				
				
				
				if(empleadodata[k].socio===this.state.socios[j].key)
				{	
					nombreSocio=this.state.socios[j].nombre+' '+this.state.socios[j].apellido;	
				}
				
			}

			for(let j=0;j<this.state.vehiculos1.length;j++){
				
				
				
				if(empleadodata[k].vehiculo===this.state.vehiculos1[j].key)
				{	
					movil=this.state.vehiculos1[j].movil;	
				}
				
			}
			
			
			if(empleadodata[k].dui!==undefined){
				
			
				newEmpleado.push({
				  key:k,
				  direccion:empleadodata[k].direccion,
				  dui:empleadodata[k].dui,
				  edad:empleadodata[k].edad,
				  latitud:empleadodata[k].latitud,
				  longitud:empleadodata[k].longitud,
				  nombre:empleadodata[k].nombre,
				  placa:empleadodata[k].placa,
				  vehiculoAnterior:empleadodata[k].placa,
				  socio:empleadodata[k].socio,
				  telefono:empleadodata[k].telefono,
				  foto:empleadodata[k].foto,
				  nombreSocio:nombreSocio,
				  vehiculo:empleadodata[k].vehiculo,
				  licencia:empleadodata[k].licencia,
				  estado:empleadodata[k].estado,
				  correo:empleadodata[k].correo,
				  movil
			  
				});
			}			
		  }
		}
		  this.setState({empleados: newEmpleado});
		}
		errData = (err) => {
	  console.log(err);
	}
	
	
	
	//get the data from the firebase and push them out
	gotDataSocios = (data) => {
		  let newSocio = []
		  if(data.val()!==null){
		  const sociodata = data.val();
		  const keys = Object.keys(sociodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
		
			newSocio.push({
			  key:k,
			  apellido:sociodata[k].Apellido,
			  nombre:sociodata[k].Nombre,
			  estado:sociodata[k].Estado
			  
			});
		  }
		  this.setState({socios: newSocio});
		}
		}
		errDataSocios = (err) => {
	  console.log(err);
	}
	
	
	
	handleClick = (rowKey) => {
		
		this.llenar();
		let vehiculostemp=[];
		let marca='';
		let modelo='';
		
		for(let i=0;i<this.state.vehiculos.length;i++)
		{
			if(this.state.vehiculos[i].key===rowKey.vehiculo)
			{
				marca=this.state.vehiculos[i].marca;
				modelo=this.state.vehiculos[i].modelo;	
			}

			if((this.state.vehiculos[i].codigo_socio===rowKey.socio) && (this.state.vehiculos[i].estado!=='Asignado')){
				
				vehiculostemp.push(this.state.vehiculos[i]);
		
			}
				
		}
			
		
		
		if(rowKey.vehiculo  === 'noVehiculo'){
			this.setState({checkboxValue:true,marca:'',modelo:''})
		}
		else{
			this.setState({checkboxValue:false,marca:marca,modelo:modelo,})
		}
		
		
		this.setState({
		    keyRow:rowKey.key,
			direccion:rowKey.direccion,
			dui:rowKey.dui,
			edad:rowKey.edad,
			licencia:rowKey.licencia,
			latitud:rowKey.latitud,
			longitud:rowKey.longitud,
			nombre:rowKey.nombre,
			placa:rowKey.placa,
			vehiculoAnterior:rowKey.vehiculo,
			vehiculo:rowKey.vehiculo,
			socio:rowKey.socio,
			telefono:rowKey.telefono,
			foto:rowKey.foto,
			nombreSocio:rowKey.nombreSocio,
			vehiculos:vehiculostemp,
			estado:rowKey.estado,
			correo:rowKey.correo
		});
	  
		this.toggleModalUpdate();
	}
	
	handleClickSocios=(rowKey) =>{
		
		
		
		this.setState({
			
			marca:'',
			modelo:''
			
		})
		
		this.llenar();
	
		this.setState({
			
			nombreSocio: rowKey.nombre+' '+rowKey.apellido,
			socio:rowKey.key
			
		})
		
		
		  let vehiculotemp=[];
		
		  for (let i = 0; i <this.state.vehiculos.length; i++) {
			
			
			
			if((rowKey.key===this.state.vehiculos[i].codigo_socio) && (this.state.vehiculos[i].estado!=='Asignado') ){
				
				
				vehiculotemp.push({
					
					
					  key:this.state.vehiculos[i].key,
					  anio:this.state.vehiculos[i].anio,
					  capacidad:this.state.vehiculos[i].capacidad,
					  codigo_socio:this.state.vehiculos[i].codigo_socio,
					  disponibilidad:this.state.vehiculos[i].disponibilidad,
					  estado:this.state.vehiculos[i].estado,
					  foto:this.state.vehiculos[i].foto,
					  marca:this.state.vehiculos[i].marca,
					  modelo:this.state.vehiculos[i].modelo,
					  placa:this.state.vehiculos[i].placa,
					  movil:this.state.vehiculos[i].movil,

				});
				
				
			}
			
			
		  }
		  
		  this.setState({
			  
			 vehiculos:vehiculotemp 
		  });
		
		
		
		this.toggleModalSocios();
	}
	
	handleClickVehiculos=(rowKey)=>{
		
		this.setState({
			vehiculoKey:rowKey.key,	
			marca:rowKey.marca+' ',
			modelo:rowKey.modelo
		});
		
		this.toggleModalVehiculos();
		
	}
	
	
	
	toggleModalUpdate=()=>{
		
		this.setState({
			uploadValue:0,
			isActive:!this.state.isActive
		})		
	}
	
	toggleModalSocios=()=>
	{
		this.setState({
			
			
			isActiveSocios:!this.state.isActiveSocios
			
		})
		
		
	}
	
	
	updateRow=()=>{
		let actua=false;
		if(this.state.checkboxValue === false){
			if(this.state.vehiculoKey=== ''){
				// actua=true;
				// this.state.vehiculoKey=this.state.vehiculoAnterior;	
				this.state.vehiculoKey = 'noVehiculo'	
			}
		}
		else{
			this.state.vehiculoKey = 'noVehiculo'
		}
		
	
	
		//Archivo de la imagen
	   let archivo=this.state.files;
	
	   let nodoHijo=this.keyRow.value;
	
	   //Datos del empleado
	   let nombre=this.nombreEmpleado.value;
	   let dui=this.duiEmpleado.value;
	   let edad=this.edadEmpleado.value;
	   let telefono=this.telefonoEmpleado.value;
	   let vehiculo=this.state.vehiculoKey;
	   let direccion=this.direccionEmpleado.value;
	   let socio=this.state.socio;
	   let licencia=this.licenciaEmpleado.value;
	   let estado=this.estado.value;
	   
	   
	   
		if(archivo===null)
		{
			let objVehiculo={tipo_vehiculo:''}
			if(this.state.checkboxValue === false){
				objVehiculo = this.state.vehiculos1.find(v=>v.key===vehiculo);
			}
			else{
				objVehiculo.tipo_vehiculo = 'noVehiculo';
			}
			
			this.empleadosRef.child(nodoHijo).update({   
			   nombre:nombre,
			   dui:dui,
			   edad:edad,
			   telefono:telefono,
			   direccion:direccion,
			   socio:socio,
			   licencia:licencia,
			   vehiculo:vehiculo,
			//    tipo_vehiculo:objVehiculo.tipo_vehiculo,
			   estado:estado
			});
			this.empleadosGPSRef.child(nodoHijo).update({   
				nombre:nombre,
				dui:dui,
				edad:edad,
				telefono:telefono,
				direccion:direccion,
				socio:socio,
				licencia:licencia,
				vehiculo:vehiculo,
				// tipo_vehiculo:objVehiculo.tipo_vehiculo,
				estado:estado
			 });
			//  if(actua===true)
			//  {
			// 	database.ref().child('Vehiculos').child(this.state.vehiculoAnterior).update({
						
			// 		estado:'Asignado'
			// 	})

			//  }else{
			// 	database.ref().child('Vehiculos').child(this.state.vehiculoAnterior).update({
						
			// 		estado:'Disponible'
			// 	})
			//  }
		
			Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
			sendLog({tipo: 'conductor_editado', informacion_extra: { nodoHijo }})
			this.toggleModalUpdate();
			
		}
		else{
			
			const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);
		
			const task= storageRef.put(archivo);
		
		
			task.on('state_changed', snapshot =>{
		
		
					this.setState({
					  uploadValue :50,
					})

			}, error =>{ console.log(error.message);
			},
			async ()=>{
				const url = await task.snapshot.ref.getDownloadURL();
				let objVehiculo={tipo_vehiculo:''}
				if(this.state.checkboxValue === false){
					objVehiculo = this.state.vehiculos1.find(v=>v.key===vehiculo);
				}
				else{
					objVehiculo.tipo_vehiculo = 'noVehiculo';
				}

					this.empleadosRef.child(nodoHijo).update({   
						nombre:nombre,
						dui:dui,
						edad:edad,
						telefono:telefono,
						direccion:direccion,
						socio:socio,
						licencia:licencia,
						vehiculo:vehiculo,
						// tipo_vehiculo:objVehiculo.tipo_vehiculo,
						estado:estado,
						foto:url
					   
					});	
					this.empleadosGPSRef.child(nodoHijo).update({	   
						nombre:nombre,
						dui:dui,
						edad:edad,
						telefono:telefono,
						direccion:direccion,
						socio:socio,
						licencia:licencia,
						vehiculo:vehiculo,
						// tipo_vehiculo:objVehiculo.tipo_vehiculo,
						estado:estado,
						foto:url
					});	
					if(actua===true)
					{
						database.ref().child('Vehiculos').child(this.state.vehiculoAnterior).update({
								
							estado:'Asignado'
						})

					}else{
						database.ref().child('Vehiculos').child(this.state.vehiculoAnterior).update({
								
							estado:'Disponible'
						})
					}		 
					
					this.setState({
						uploadValue:100
					});

					
					Alert.success('Datos actualizados correctamente', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
					});	

					this.toggleModalUpdate();
			});
		
		}
		
		
		
		
		try{			
					if(estado==='desactivo'){
						
						this.vehiculosRef.child(this.state.vehiculoAnterior).update({
							estado:'Disponible'
						});
						
					}
					else{
						this.vehiculosRef.child(this.state.vehiculoAnterior).update({
							estado:'Disponible'
						});
						this.vehiculosRef.child(this.state.vehiculoKey).update({
		
							estado:'Asignado'
						});
							
					}
					
		}
		catch(err){
			
			console.log(err);
		}
		
		
	}
 
 
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
 
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}

				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
				reader.readAsDataURL(file);	
		}
	}
	
	
	btnSoiciosFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickSocios(row)}} >Seleccionar</button>;
	}
	btnVehiculosFormatter(cell,row){
		
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickVehiculos(row)}} >Seleccionar</button>;
	}


	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}
	
	handleKeyPressNumeros=(e)=>{
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	}

	handleKeyPressLicencia(e) {
		let licencia = this.licenciaEmpleado.value;
		let tecla = e.which;
		let tecla_final = String.fromCharCode(tecla);
		let longitudSinGuiones = licencia.replace(/-/g, '').length;

		let esDigito = /^[0-9]+$/.test(tecla_final);

		let permitirGuion = (tecla === 45) && (
			(longitudSinGuiones === 4 || longitudSinGuiones === 10 || longitudSinGuiones === 13) && licencia.match(/^\d{4}-?\d{0,6}-?\d{0,3}-?\d{0,1}$/) != null || // Para el patrón 1
			(longitudSinGuiones === 8 && licencia.match(/^\d{8}-?\d{0,1}$/) != null) // Para el patrón 2
		);

		if ((!permitirGuion && !esDigito) || longitudSinGuiones >= 17) {
			e.preventDefault();
		}
	}

	validateLicencia() {
		let licencia = this.licenciaEmpleado.value;

		let patron1Completo = /^\d{4}-\d{6}-\d{3}-\d{1}$/.test(licencia);
		let patron2Completo = /^\d{8}-\d{1}$/.test(licencia);

		if (!patron1Completo && !patron2Completo) {
			this.licenciaEmpleado.setCustomValidity("La licencia ingresada no cumple con los patrones requeridos.");
		} else {
			this.licenciaEmpleado.setCustomValidity("");
		}
		this.licenciaEmpleado.reportValidity();
	}
	
	ocultarMenu() {
		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	asignarAncho(){
		
		if(this.state.anchoAnterior!==window.innerWidth){
			
			this.setState({
				
				anchoActual:window.innerWidth
				
			})
			
		}
		
		
	}
	toggleCheckboxValue = () => {
		this.setState({checkboxValue:!this.state.checkboxValue, vehiculoKey:'noVehiculo'})
	  }
	
	render(){

		let {checkAdmin} = this.state;
		
		return(
		
			<div className="Vehiculos container" onClick={this.ocultarMenu}>

			
			<Modal_Empleados/>
			{this.state.template ? <Alert  timeout='none' stack={{limit: 1}} contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 1}} html={true} />}

			<div style={{ marginTop: 20 }}>
					<ExcelFile filename="Reportes de conductores" element={<button filename="Reporte 1" className="btn btn-success">Exportar Excel</button>}>
						<ExcelSheet data={this.state.empleados} name="Detalle de Reporte">
							<ExcelColumn label="Nombre" value="nombre" />
							<ExcelColumn label="Correo" value="correo" />
							<ExcelColumn label="Móvil" value="movil" />
							<ExcelColumn label="DUI" value="dui" />
							<ExcelColumn label="Edad" value="edad" />
							<ExcelColumn label="Socio" value="nombreSocio" />
							<ExcelColumn label="Teléfono" value="telefono" />
							<ExcelColumn label="Dirección" value="direccion"/>
							<ExcelColumn label="Estado" value="estado" />
						</ExcelSheet>
					</ExcelFile>
				</div>
			
			<BootstrapTable data={ this.state.empleados }
			ref='table'
			pagination={ true }
			search={ true }
			hover
			>
			
			
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='nombre' dataSort={true}>Nombre</TableHeaderColumn>
				{/* <TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='movil' dataAlign='center' dataSort={true}>Movil</TableHeaderColumn> */}
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='dui' dataSort={true}>Dui</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='edad' dataSort={true}>Edad</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='nombreSocio' dataSort={true}>Socio</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='telefono' dataSort={true}>Telefono</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='direccion' dataSort={true}>Direccion</TableHeaderColumn>
				<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='estado' dataSort={true}>Estado</TableHeaderColumn>				 
			
					<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
			
			</BootstrapTable>

				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate} style={customStyles} >

					<form method="POST" action="" onSubmit={this.handleClickAlerta} >

						<h3>Modificar Empleado</h3>
						<hr />
						<input type="hidden" ref={input => { this.keyRow = input; }} value={this.state.keyRow} />

						{/* <input className="form-check-input" type="checkbox" defaultChecked={this.state.checkboxValue} onChange={this.toggleCheckboxValue} ref="check_me"  id="defaultCheck1"/>
								<label className="form-check-label" htmlFor="defaultCheck1">Sin vehículo</label>
								 */}
						<div className="form-group">
							<label htmlFor="nombre" >Nombre:</label>
							<input type="text" className="form-control" name="nombre"
								ref={input => { this.nombreEmpleado = input; }}
								onKeyPress={this.handleKeyPressLetras}
								placeholder="Nombre"
								required
								defaultValue={this.state.nombre}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="dui" >Dui:</label>
							<input type="text" className="form-control" name="dui"
								ref={input => { this.duiEmpleado = input; }}
								onKeyPress={this.handleKeyPressNumeros}
								maxLength="10" minLength="10"
								placeholder="Dui"
								required
								defaultValue={this.state.dui}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="edad" >Edad:</label>
							<input type="text" className="form-control" name="edad"
								ref={input => { this.edadEmpleado = input; }}
								onKeyPress={this.handleKeyPressNumeros}
								placeholder="Edad"
								maxLength="2" minLength="2"
								autoComplete="off" required
								defaultValue={this.state.edad}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="direccion" >Direccion:</label>
							<input type="text" className="form-control" name="direccion"
								ref={input => { this.direccionEmpleado = input; }}
								placeholder="Placa"
								autoComplete="off" required
								defaultValue={this.state.direccion}
							/>
						</div>
						<div className="form-group">
							<label htmlFor="correo">Correo</label>
							<input type="text" className="form-control" name="correo"
								ref={input => { this.correoEmpleado = input }}
								autoComplete="off" value={this.state.correo}
								disabled="disabled"
							/>
						</div>
						<div className="form-group">
							<label htmlFor="licencia">Licencia</label>
							<input type="text" className="form-control" name="licencia"
								ref={input => { this.licenciaEmpleado = input; }}
								placeholder="Licencia" required
								onChange={this.validateLicencia.bind(this)}
								autoComplete="off"
								defaultValue={this.state.licencia}
								onKeyPress={this.handleKeyPressLicencia}
								maxLength="17"
							/>
						</div>

						<div className="form-group">
							<label htmlFor="telefono" >Telefono:</label>
							<input type="text" className="form-control" name="capacidad"
								ref={input => { this.telefonoEmpleado = input; }}
								minLength="8" maxLength="8"
								placeholder="Telefono"
								autoComplete="off" required
								onKeyPress={this.handleKeyPressNumeros}
								defaultValue={this.state.telefono}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="socio" >Socio:</label>
							<input type="text" className="form-control" name="socio"
								ref={input => { this.socioEmpleado = input; }}
								placeholder="Elige un socio"
								autoComplete="off" required
								value={this.state.nombreSocio} readOnly="readonly"
								onClick={this.toggleModalSocios}
							/>
						</div>
						{/* {!this.state.checkboxValue && 	
									<div className="form-group">
										<label  htmlFor="placa" >Vehiculo:</label>
										<input type="text" className="form-control" name="placa"
											ref={input => {this.placaEmpleado=input;}}
											placeholder="Placa"
											autoComplete="off" required
					      					value={this.state.marca+' '+this.state.modelo}
											onClick={this.toggleModalVehiculos}
											readOnly="readOnly"
										/>
									</div>
									}
									{this.state.checkboxValue &&
										<div className="form-group">
											<input className="form-control" type="text" placeholder="Conductor en espera" readOnly/>
										</div>
									} */}
									
									<div className="form-group">
										<label htmlFor="estado">Estado</label>
										<select name="estado" className="form-control" 
											ref={input=>{this.estado=input;}}
											defaultValue={this.state.estado}
										>
											<option>activo</option>
											<option>desactivo</option>
										</select>
									</div>
									
									
									<div className="form-group">
										<label htmlFor="foto">Foto del conductor</label>
										<br/>
										<progress value={this.state.uploadValue} max="100"></progress>
										<input type="file" className="form-control"  onChange={this.handleUpload}/>
									</div>
									<img src={this.state.foto} alt="Foto del conductor" className="foto" width="240px"/>
								<hr/>
								<button className="btn btn-primary buttons" type="submit">Guardar</button>
								
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal> 
			  
					
		
					<Modal isOpen={this.state.isActiveSocios} onRequestClose={this.toggleModalSocios}  style={customStyles}>
						<h4>Selecciona un socio</h4>
						<hr/>
					
						<BootstrapTable data={ this.state.socios}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnSoiciosFormatter.bind(this) }>Editar</TableHeaderColumn>
						</BootstrapTable>
					
					</Modal>

					<Modal isOpen={this.state.isActiveVehiculos} onRequestClose={this.toggleModalVehiculos}  style={customStyles}>
						<h4>Selecciona un vehiculo</h4>
						<hr/>
					
					
							<BootstrapTable data={ this.state.vehiculos}
								 ref='table'
								 pagination={ true }
								 search={ true }
								 hover
								 >
								<TableHeaderColumn  dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn  dataField='movil' dataSort={true}>Movil</TableHeaderColumn>
								<TableHeaderColumn  dataField='modelo' dataSort={true}>Modelo</TableHeaderColumn>
								<TableHeaderColumn  dataField='placa'>Placa</TableHeaderColumn>
	
								 <TableHeaderColumn  dataField='edit' dataAlign='center' dataFormat={ this.btnVehiculosFormatter.bind(this) }>Editar</TableHeaderColumn>
							</BootstrapTable>								
						
					</Modal>

					
			  
					<footer class="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div class="container">
						<div class="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div class="col-sm">
								<img src={copyright} />
							</div>
						</div>
					</div>
				</footer>
			</div>
		);
	}
}


export default Empleados;


// WEBPACK FOOTER //
// ./src/Components/Empleados/Empleados.jsx